export default "__VITE_ASSET__cc187a9e__"